import { GetBannersParams } from '../__generated__/gateway/gatewayApiTypes';
import { TBannersList } from '../interfaces/advertising';

import ProxyClient from './clients/ProxyClient';

export const getBanners = async ({ params }: { params: GetBannersParams }) => {
  const { data } = await ProxyClient.get<TBannersList>('/banners', { params });

  return data;
};
